import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { ToastMain, SweetAlertShow } from "../../master/Master";
import { Question } from "../../../api/TypeServices";
import { courseList } from "../../../api/Courses";
import { getSbjById } from "../../../api/Subjects";
import { useNavigate } from "react-router-dom";
import TestLayout from "./TestLayout";

const TypeWriter = () => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    question: "",
    options: ["", "", "", ""],
    correct_answer: "",
  });
  const [courses, setCourses] = useState([]);

  const [syllabus, setSyllabus] = useState([]);
  const [subject, setSubject] = useState([]);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const [selectedCourse, setSelectedCourse] = useState("");
  const id = selectedCourse;
  const [selectedSubject, setSelectedSubject] = useState("");

  const handleOptionChange = (index, value) => {
    const newOptions = [...form.options];
    newOptions[index] = value;
    setForm({ ...form, options: newOptions });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        subject_id: selectedSubject,
        question: form.question,
        option_a: form.options[0],
        option_b: form.options[1],
        option_c: form.options[2],
        option_d: form.options[3],
        correct_answer: form.correct_answer,
      };

      await Question(payload);

      ToastMain.fire({
        icon: "success",
        title: "Question Added Successfully",
      });

      // ✅ Clear form for next question
      setForm({
        question: "",
        options: ["", "", "", ""],
      });
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || "Something went wrong",
      // });
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    }
  };

  const subjectFetchByID = async (id) => {
    setLoading(false);
    try {
      const response = await getSbjById(id);
      if (response.data.status) {
        setSubject(response?.data?.data);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || error?.response?.message || "Something Want Wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      subjectFetchByID(id);
      // alert('api chal gai' + id)
    }
  }, [selectedCourse]);

  const courseFetch = async () => {
    setLoading(true);
    try {
      const response = await courseList();
      if (response.data.status) {
        setCourses(response?.data?.data);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    courseFetch();
  }, []);

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Header />
        <div className="layout-page">
          <Nav />
          <div className="content-wrapper">
            <div className="container-fluid">
              <div className="row">
                <TestLayout />
                <div className="col-12">
                  <div className="card mb-2">
                    <div className="card-body">
                      <h3 className="mb-3 text-primary">Add Question</h3>
                      <div className="d-flex p-3 gap-1">
                        <div className="col-md-3">
                          <div className="form-floating form-floating-outline">
                            <select
                              className="form-select"
                              name="course_id"
                              id="course"
                              value={selectedCourse}
                              onChange={(e) =>
                                setSelectedCourse(e.target.value)
                              }
                            >
                              <option
                                value=""
                                onClick={() => {
                                  setSubject("");
                                }}
                              >
                                Select Course
                              </option>
                              {courses?.map((item, index) => (
                                <option key={item?.id} value={item?.id}>
                                  {item?.title}
                                </option>
                              ))}
                            </select>
                            <label htmlFor="course">Course</label>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-floating form-floating-outline mb-4">
                            <select
                              className="form-select"
                              name="subject"
                              value={selectedSubject}
                              onChange={(e) =>
                                setSelectedSubject(e.target.value)
                              }
                            >
                              <option>Select Subject</option>
                              {subject?.subjects_list?.map((sub) => (
                                <option key={sub.id} value={sub.id}>
                                  {sub.name}
                                </option>
                              ))}
                            </select>
                            <label>Select Subjects</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <form onSubmit={handleSubmit} className="card p-3">
                    {/* Question */}
                    <textarea
                      className="form-control mb-3"
                      placeholder="Enter Question"
                      rows="3"
                      value={form.question}
                      onChange={(e) =>
                        setForm({ ...form, question: e.target.value })
                      }
                      required
                    />

                    {/* Options */}
                    {form.options.map((opt, i) => (
                      <input
                        key={i}
                        className="form-control mb-2"
                        placeholder={`Option ${String.fromCharCode(65 + i)}`}
                        value={opt}
                        onChange={(e) => handleOptionChange(i, e.target.value)}
                        required
                      />
                    ))}
                    <select
                      className="form-control mb-3"
                      value={form.correct_answer}
                      onChange={(e) =>
                        setForm({ ...form, correct_answer: e.target.value })
                      }
                      required
                    >
                      <option value="">Select Correct Answer</option>
                      <option value="A">Option A</option>
                      <option value="B">Option B</option>
                      <option value="C">Option C</option>
                      <option value="D">Option D</option>
                    </select>

                    <button className="btn btn-success w-100">
                      Submit Question
                    </button>
                  </form>

                  <small className="text-muted"></small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypeWriter;
